export enum QueryParamsForTaggingEnum {
	SPECIALTY_CODE = 'specialty_code',
	SPECIALTY_NAME = 'specialty_name',
	UNIT_CODE = 'unit_code',
	UNIT_NAME = 'unit_name',
	UNIT_ADDRESS = 'unit_address',
	PROFESSIONAL_NAME = 'professional_name',
	PROFESSIONAL_CODE = 'professional_code',
	DATE_AT = 'date_at',
	HOUR_AT = 'hour_at',
	UF_CODE = 'uf_code',
	UF_NAME = 'uf_name',
	CITY_NAME = 'city_name',
	DISABILITY = 'disability',
	DISTRICT_NAME = 'district_name',
	INCLUDE_NEIGHBORHOOD = 'include_neighborhood',
	SUB_SPECIALTY_CODE = 'sub_specialty_code',
	STEP = 'step',
	SHIFT = 'shift',
	IS_REBOOKING = 'is_rebooking',
	BOOKING_NUMBER = 'booking_number',
	BOOKING_TYPE = 'booking_type',
	PROTOCOL_NUMBER = 'protocol_number',
	ODONTO_RECOMMENDATIONS = 'odonto_recommendations',
	MULTIPLE_BOOKINGS = 'multiple_bookings',
	BOOKING_ORIGIN = 'booking_origin',
	BOOKING_REDIRECT = 'booking_redirect',
	SEND_REFUND_DOCS_STEP = 'send_refund_docs_step',
	SEND_REFUND_DOCS_PROTOCOL_NUMBER = 'send_refund_docs_protocol_number',
	REQUEST_PREVIEW_REFUND_STEP = 'request_preview_refund_step',
	REQUEST_PREVIEW_REFUND_PROTOCOL_NUMBER = 'request_preview_refund_protocol_number',
	REQUEST_REFUND_STEP = 'request_refund_step',
	REQUEST_REFUND_TYPE_SERVICE = 'request_refund_type_service',
	REQUEST_REFUND_TYPE_PROVIDER = 'request_refund_type_provider',
	REQUEST_REFUND_SPECIALITY = 'request_refund_speciality',
	REQUEST_REFUND_UF = 'request_refund_uf',
	REQUEST_REFUND_CITY = 'request_refund_city',
	REQUEST_REFUND_PROTOCOL_NUMBER = 'request_refund_protocol_number',
	SHOW_BE_BORN_WELL_NOT_REGISTER = 'show_be_born_well_not_register',
	FIRST_VISIT = 'first_visit',
	GEOLOCATION = 'geolocation',
	REQUEST_AUTH_STEP = 'request_auth_step',
	BENEFICIARY_CARD = 'beneficiary_card',
}
